import { render } from "./configuracao.vue?vue&type=template&id=57c6a66d"
import script from "./configuracao.vue?vue&type=script&lang=js"
export * from "./configuracao.vue?vue&type=script&lang=js"

import "./configuracao.vue?vue&type=style&index=0&id=57c6a66d&lang=css"

import exportComponent from "/opt/buildhome/repo/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__